"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ne": {
    "eafe6d79": [{
      "hkey": "a59181b2",
      "slug": "campo-di-ne",
      "name": "Campo di Ne",
      "primary": true,
      "skipSearch": false
    }],
    "ne": [{
      "hkey": "a59181b2",
      "slug": "campo-di-ne",
      "name": "Campo di Ne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "00f51ba0": [{
      "hkey": "4e89b2f0",
      "slug": "pontori-ria",
      "name": "Pontori-Ria",
      "primary": true,
      "skipSearch": false
    }],
    "pontori": [{
      "hkey": "4e89b2f0",
      "slug": "pontori-ria",
      "name": "Pontori-Ria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eef90e1a": [{
      "hkey": "37087a3b",
      "slug": "ne",
      "name": "Ne",
      "primary": true,
      "skipSearch": false
    }],
    "graveglia": [{
      "hkey": "37087a3b",
      "slug": "ne",
      "name": "Ne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c06f19dd": [{
      "hkey": "154a7fb4",
      "slug": "botasi-prato-reppia",
      "name": "Botasi-Prato-Reppia",
      "primary": true,
      "skipSearch": false
    }],
    "reppia": [{
      "hkey": "154a7fb4",
      "slug": "botasi-prato-reppia",
      "name": "Botasi-Prato-Reppia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;